import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingWebpToPngConfig } from '@/data/landingConfig/landingWebpToPngConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_WebpToPng } from './schemaObject';

interface Props {}
const WebpToPngConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_WebpToPng} />
			<LandingTemplate
				data={landingWebpToPngConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default WebpToPngConverter;
